import Phaser from 'phaser';
import {
  GRASS_FRAME_WIDTH,
  GRASS_FRAME_HEIGHT,
  TREE_FRAME_WIDTH,
  TREE_FRAME_HEIGHT,
  PLAYER_FRAME_WIDTH,
  PLAYER_FRAME_HEIGHT,
  PLAYER_FRAMES_PER_DIR,
  PLAYER_WALK_FRAMERATE,
  DIR_ROW,
} from '../constants';

/**
 * BootScene
 * ─────────
 * Loads external assets (grass spritesheet, pre-extracted archer walk PNG)
 * and generates runtime placeholder textures, then starts GameScene.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    this.load.spritesheet('grass', '/ironkeep/res/grass_sprites.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('grass_features', '/ironkeep/res/grass_sprites_features.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('grass_obstructions', '/ironkeep/res/grass_sprites_obstructions.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('grass_sprites_patchy', '/ironkeep/res/grass_sprites_patchy.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('dirt', '/ironkeep/res/dirt_sprites.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('dirt_features', '/ironkeep/res/dirt_sprites_features.png', {
      frameWidth: GRASS_FRAME_WIDTH,
      frameHeight: GRASS_FRAME_HEIGHT,
    });
    this.load.spritesheet('trees', '/ironkeep/res/grass_sprites_trees.png', {
      frameWidth: TREE_FRAME_WIDTH,
      frameHeight: TREE_FRAME_HEIGHT,
    });

    // Pre-extracted walk cycle: 8 cols (anim frames) × 8 rows (directions)
    this.load.spritesheet('peasant', '/ironkeep/res/archer_walk.png', {
      frameWidth: PLAYER_FRAME_WIDTH,
      frameHeight: PLAYER_FRAME_HEIGHT,
    });
  }

  create() {
    this.createPlayerAnimations();
    this.generateSlotTexture();
    this.scene.start('GameScene');
  }

  /* ── Player animations ──────────────────────────────────────── */

  createPlayerAnimations() {
    // Spritesheet layout: rows = directions, cols = walk frames.
    // Frame index = dirRow * PLAYER_FRAMES_PER_DIR + animCol
    const dirs = Object.keys(DIR_ROW);

    dirs.forEach((dir) => {
      const row = DIR_ROW[dir];
      const startFrame = row * PLAYER_FRAMES_PER_DIR;
      const endFrame = startFrame + PLAYER_FRAMES_PER_DIR - 1;

      this.anims.create({
        key: `walk_${dir}`,
        frames: this.anims.generateFrameNumbers('peasant', {
          start: startFrame,
          end: endFrame,
        }),
        frameRate: PLAYER_WALK_FRAMERATE,
        repeat: -1,
      });
    });

    // Idle = first frame of the south-facing row
    const idleRow = DIR_ROW.s;
    this.anims.create({
      key: 'idle',
      frames: [{ key: 'peasant', frame: idleRow * PLAYER_FRAMES_PER_DIR }],
      frameRate: 1,
      repeat: 0,
    });
  }

  /* ── UI slot texture ──────────────────────────────────────────── */

  generateSlotTexture() {
    const size = 56;
    const gfx = this.make.graphics({ add: false });
    gfx.fillStyle(0x333344, 0.85);
    gfx.fillRoundedRect(0, 0, size, size, 6);
    gfx.lineStyle(2, 0x888899, 0.7);
    gfx.strokeRoundedRect(0, 0, size, size, 6);
    gfx.generateTexture('slot', size, size);
    gfx.destroy();
  }
}
